module.exports = __webpack_public_path__ + "img/la-times-logo.6c2542cd.png";